import { Component, Input, OnInit } from '@angular/core';
import { Paths } from '../../../config/config';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuotationComponent } from '../../components/modals/quotation/quotation.component';

@Component({
  selector: 'app-box-accessory',
  templateUrl: './box-accessory.component.html',
  styleUrls: ['./box-accessory.component.scss']
})
export class BoxAccessoryComponent implements OnInit {

  @Input() title;
  @Input() img;
  @Input() code;
  @Input() categoryId;
  @Input() description;

  public readonly Paths = Paths;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  openQuotation() {
    const quotationModal = this.modalService.open(QuotationComponent, {
      backdropClass: 'modals-backdrop-custom',
      windowClass: 'quotation-window'
    });

    quotationModal.componentInstance.accessoryCategory = this.categoryId;
  }
}
